import React from 'react';
import { createStyles } from './styles';
import EeClassBlock from '../EeClassBlock/index';
import EeClassTypeTitle from '../EeClassTypeTitle';

const EeClassesGuidelines = (): JSX.Element => {
  const classes = createStyles();
  return (
    <div className={classes.guidelinesContent}>
      <p>
        Use Classes and Locations to organize employees and manage product line availability. You can choose from our
        Stock classes or you can create your own Custom or Location based classes.
      </p>
      <p>
        Remember to remove any Stock or Custom/Location class not being used. Once you&apos;ve created your classes, you
        will be prompted to verify what product lines are available by class.
      </p>
      <p>
        Finally, once you activate classes - you will have to assign each employee in the elections page to a class or
        location before you close open enrollment.
      </p>
      <EeClassTypeTitle type="STOCK" styles={classes.typeTitle} />
      {/* need only for demo */}
      <EeClassBlock
        classInfo={{
          type: 'STOCK',
          name: 'Retirees',
          periodId: '',
          validationMessage: '',
          id: 'guideInput',
          groupId: '',
        }}
      />
    </div>
  );
};

export default EeClassesGuidelines;
